import React from 'react';
import { List, Datagrid, EditButton, TextInput, BooleanInput, Filter } from 'react-admin';

import { LookupFields } from '../customFields';

const QuickKeyFunctionFilter = (props) => (
	<Filter {...props}>
		<TextInput source="name" alwaysOn />
		<BooleanInput source="active" alwaysOn />
	</Filter>
);

const QuickKeyFunctionDataGrid = (props) => (
	<Datagrid rowClick="show" {...props}>
		{LookupFields(props)}
		<EditButton />
	</Datagrid>
);

const QuickKeyFunctionList = (props) => (
	<List
		filters={<QuickKeyFunctionFilter />}
		filterDefaultValues={{ active: true }}
		sort={{ field: 'createdAt', order: 'DESC' }}
		bulkActionButtons={false}
		{...props}
	>
		<QuickKeyFunctionDataGrid />
	</List>
);

export default QuickKeyFunctionList;
